import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function () { return ({
    root: {
        width: "100%",
        height: "fit-content",
    },
    appBar: {
        position: "relative",
        boxShadow: "none",
    },
    toolbar: {
        minHeight: "40px",
        boxShadow: "0px 0px 1px rgba(0,0,0,0.5)",
        backgroundColor: "#FEFEFF",
        padding: "0px 8px !important",
    },
    menuIcon: {
        margin: "0px !important",
        padding: "5px",
        "& svg": {
            fill: "#111629",
        },
    },
    pageTitle: {
        color: "black",
        lineHeight: "30px",
    },
}); });
